import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import client from './rest/AdminClient';

const _getBridgeReasonCodes = () => {
  const queryString = qs.stringify({
    default: true,
  });

  return client({
    method: 'GET',
    path: `/api/v2/shippers/reason-codes?${queryString}`,
  });
};

export const getBridgeReasonCodes = async () => {
  const response = await _getBridgeReasonCodes();
  const items = response?.entity?.result?.items || [];
  return items;
};

export const useGetBridgeReasonCodes = (options = {}) => {
  return useQuery({
    queryKey: ['bridgeReasonCodes'],
    queryFn: getBridgeReasonCodes,
    retry: 1,
    ...options,
  });
};

const _createException = (payload) => {
  return client({
    method: 'POST',
    path: `/admin/api/market-exceptions/bulk`,
    entity: JSON.stringify(payload),
  });
};

export const createException = async (body) => {
  const response = await _createException(body);
  const items = response?.entity || {};
  return items;
};

const _getExceptions = (params) => {
  const queryString = qs.stringify(params);

  return client({
    method: 'GET',
    path: `/admin/api/market-exceptions/shipment?${queryString}`,
  });
};

export const getExceptions = async (params) => {
  const response = await _getExceptions(params);
  const items = response?.entity?.items || [];
  return items;
};

export const useGetExceptions = (params, options = {}) => {
  return useQuery({
    queryKey: ['exceptions', params?.shipment_id],
    queryFn: () => {
      return getExceptions(params);
    },
    enabled: !!params?.shipment_id,
    ...options,
  });
};

export const _getBridgeCodeFilters = (params) => {
  const queryString = qs.stringify(params);
  return client({
    method: 'GET',
    path: `/admin/api/market-exceptions/filters?${queryString}`,
  });
};

export const getBridgeCodeFilters = async (filterType) => {
  const response = await _getBridgeCodeFilters({ filterType });
  const items = response?.entity?.filterOptions || [];
  return items;
};
